import { createApp } from 'vue'
import App from './App.vue'
import router from '@/micro/router/router'
import '../node_modules/@alegradev/smile-ui-next/dist/style.css'
import './index.css'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'

import { defineCustomElement } from 'vue'
import TagElementCe from './micro/widgets/citations/CitationTag.ce.vue'

const TagComponent = defineCustomElement(TagElementCe)
customElements.define('nms-tag', TagComponent)

const pinia = createPinia()
const app = createApp(App)

Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router })],
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

app.use(router)
app.use(pinia)
app.mount('#app')
